








import { Component, Vue } from 'vue-property-decorator';

import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';

@Component({
	name: 'PagePages',
	components: {
		Sidebar,
	},
})
export default class Page extends Vue {
	private component: any;

	constructor() {
		super();

		this.component = (): void => null;
	}

	get page(): string {
		return this.$route.params.pathMatch;
	}

	private mounted() {
		switch (this.page) {
			// case 'cme':
			// 	this.component = () =>
			// 		import(/* webpackChunkName: "UMIAPage" */ '@/components/Pages/CME.vue');
			// 	break;

			case 'cyber_info':
				this.component = () =>
					import(/* webpackChunkName: "UMIAPage" */ '@/components/Pages/CyberInfo.vue');
				break;
		}
	}
}
